import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { ApiConstants } from '../constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class ResponsibleSubBUService {
  resposibleSubBUList = [];
  constructor(private httpClient: HttpClient) {

  }
  // Need to do Update with sBU Type
  getSubBU(): Observable<any> {
    let observable: Observable<any>;
    if (this.resposibleSubBUList.length > 0) {
      observable = of(this.resposibleSubBUList);
    }
    else {
      observable = this.httpClient.get<any>(ApiConstants.SubBusinessUbits_Api)
        .pipe(
          tap(sBUData => this.resposibleSubBUList = sBUData)
        );
    }
    return observable;
  }
}
